export class JSConn {
  apiParams: any = {};
  apiCallStatus: string = "ok";
  formParams: any = {};
  fromRoutePath: string = "";
  toRoutePath: string = "";
  response: any = {};
  error: any = {};
  dataForStore: any = {};
  halted: boolean = false;
  toastMessage: string = "";

  constructor() {}
}
